var exports = {
  "n": "x52a3aa3b--30f167--link",
};

module.exports = exports;
